import { render, staticRenderFns } from "./NoticeLayer.vue?vue&type=template&id=08fb8446&scoped=true&"
import script from "./NoticeLayer.vue?vue&type=script&lang=js&"
export * from "./NoticeLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb8446",
  null
  
)

export default component.exports